/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */


import { useState } from "react"
import { Typography } from "@mui/material"
import ExpandCircleDownSharpIcon from '@mui/icons-material/ExpandCircleDownSharp'
import {ModalDialog} from "../../../../../components/ModalDialog/ModalDialog";
import ArgosFlexbox from "../../../../../components/Containers/ArgosFlexbox";
import ArgosButton from "../../../../../components/Buttons/ArgosButton";
import {dateToLocaleString} from "../../../../../../helpers/helpers";


/**
 * Dialog to view the error message details for a data set.
 */
interface IProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  data: any
}
export const ViewGenerateBluelineErrorDialog = (props: IProps) => {
  const { data, isOpen, setIsOpen } = props

  const closeDialog = () => {
    setShowStackTrace(false)
    setIsOpen(false)
  }

  const [showStackTrace, setShowStackTrace] = useState<boolean>(false)

  const toggleStackTrace = () => {
    setShowStackTrace(!showStackTrace)
  }

  /** Rotate icon for expand/collapse on toggle */
  const rotatedIconStyle = {
    transform: showStackTrace ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: 'transform 0.3s'
  }

  return (
    <ModalDialog
      open={isOpen}
      handleClose={closeDialog}
      title={'Error'}
      maxWidth={'md'}
      disableCloseOnOutsideClick={true}
    >
      <ArgosFlexbox vertical style={{padding: '0px', gap: '20px'}}>
        {!data && <ArgosFlexbox vertical style={{gap: '20px'}}>
          <Typography>Unable to display the error message. Please try again or contact the Argos team for assistance.</Typography>
        </ArgosFlexbox>}
        {data && <ArgosFlexbox vertical style={{ gap: '20px'}}>
          <Typography>
            {data.exception}
          </Typography>
          <Typography>
            Occurred on {dateToLocaleString(new Date(data.timestamp))} during Generate Performance Reports
          </Typography>
          {showStackTrace && (
            <pre
              style={{
                overflowX: 'auto', backgroundColor: '#f5f5f5', padding: '10px',
                borderRadius: '5px', whiteSpace: 'pre-wrap',
                maxHeight: 600
              }}
            >
              {data.stackTrace}
            </pre>
          )}
          <ArgosButton
            onClick={toggleStackTrace}
            variant='text'
            sx={{textTransform: 'none'}}
            startIcon={<ExpandCircleDownSharpIcon sx={rotatedIconStyle} />}
            fontSize={16}
          >
            {showStackTrace ? 'Hide logs' : 'Show logs'}
          </ArgosButton>
        </ArgosFlexbox>}
      </ArgosFlexbox>
    </ModalDialog>
  )
}